import NetInfo from '@react-native-community/netinfo'
import { onlineManager } from '@tanstack/react-query'
import { useEffect } from 'react'

/**
 * When the app is offline, the network status is set to false
 * When the app is online, the network status is set to true
 * When the app is not connected to the internet, the network status is set to null
 */
export const useNetworkStatus = () =>
  useEffect(() => {
    const unsubscribe = onlineManager.setEventListener((setOnline) => {
      return NetInfo.addEventListener((state) => {
        setOnline(!!state.isConnected)
      })
    })
    return unsubscribe
  }, [])
